var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmpty(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 448,
    height: 238,
    viewBox: "0 0 448 238",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E3E3E3",
    d: "M159.242 134.568L106.854 145.289 109.813 173.284 111.132 183.178 164.714 173.33z",
    transform: "translate(-697 -309) translate(697 309)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FBFBFB",
    d: "M118.542 105.74L219.289 36.381 272.229 116.701 179.969 179.675 164.881 176.289 154.231 173.938z",
    transform: "translate(-697 -309) translate(697 309)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E3E3E3",
    d: "M154.231 173.938L169.859 161.159 179.968 179.674z",
    transform: "translate(-697 -309) translate(697 309)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E5E5E5",
    d: "M313.153 55.757L239.28 32.546 227.319 61.16 223.376 71.439 298.027 96.209z",
    transform: "translate(-697 -309) translate(697 309)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E9E9E9",
    d: "M124.638 129.379L130.377 205.537 173.641 202.483 183.733 202.378 179.05 124.942z",
    transform: "translate(-697 -309) translate(697 309)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M301.333 126L230 137.959 232.645 175.943 233.949 189.383 306.854 178.661z",
    transform: "translate(-697 -309) translate(697 309)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#BEBEBE",
    d: "M7.726 3.275L1.516.995C.745.71-.06 1.32.002 2.136l.391 5.086c.034.44.321.82.735.971L5.35 9.745",
    transform: "translate(-697 -309) translate(697 309) translate(181 103)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E5E5E5",
    d: "M6.636 6.245l1.09-2.97-6.21-2.28C.745.71-.06 1.318.004 2.137l.132 1.72 6.5 2.387z",
    transform: "translate(-697 -309) translate(697 309) translate(181 103)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#707070",
    d: "M12.963 16.538l4.866-13.246 63.825 23.444c2.652.975 4.012 3.913 3.038 6.566l-1.338 3.643c-.975 2.653-3.913 4.012-6.566 3.038L12.963 16.538z",
    transform: "translate(-697 -309) translate(697 309) translate(181 103)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BEBEBE",
    d: "M11.636 19.458L18.706.207 82.66 23.699c1.199.44 1.813 1.769 1.372 2.967l-5.476 14.911c-.441 1.198-1.77 1.813-2.968 1.372L11.636 19.458z",
    transform: "translate(-697 -309) translate(697 309) translate(181 103)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#707070",
    d: "M20.546.883l-.248-.091-.902-.332-.866-.317c-1.197-.441-2.524.174-2.963 1.37l-.012.03c-.237.645-.754 1.156-1.412 1.35-.658.192-1.398.18-2.112-.081L9.137 1.748c-.924-.34-2.663.772-2.978 1.628L5.14 6.148 4.12 8.92c-.313.856.294 2.829 1.218 3.168l2.793 1.026c.726.267 1.327.748 1.727 1.334.397.58.47 1.322.228 1.98-.44 1.198.175 2.525 1.372 2.965l.865.318.903.33.248.092 7.07-19.25z",
    transform: "translate(-697 -309) translate(697 309) translate(181 103)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E5E5E5",
    d: "M17.702 8.625l62.113 22.816c1.199.441 1.814 1.769 1.373 2.967l2.844-7.742c.441-1.198-.174-2.527-1.372-2.967L20.546.883l-2.844 7.742z",
    transform: "translate(-697 -309) translate(697 309) translate(181 103)"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.e49fb8cb7445bab26b0a1c3bc60040d5.svg";
export { ForwardRef as ReactComponent };